import DetailsPageTitle from "components/common/DetailsPageTitle";
import Spinners from "components/common/Spinners";
import {
  formatDate,
  formatDateTime,
  formatToCustomDateTime,
  getRelativeTimeFromNow,
} from "components/common/Utils";
import React, { useEffect, useState } from "react";
import { Col, Container, Modal, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import {
  generateOrderInvoice,
  getOrderDetails,
} from "store/actions/orderSlice";
import CancelOrder from "./CancelOrder";
import { orderStatusTypes } from "components/constants/StatusKeys";
import {
  genderOptions,
  orderSpaceType,
  userRoleType,
} from "components/constants/DropdownOptions";
import { showAlert } from "store/reducers/alertReducer";
import CustomStar from "components/common/CustomStar";
import walletIcon from "assets/images/icons/wallet.svg";
import paymentMethodIcon from "assets/images/icons/paymentMethod.svg";
import applePayIcon from "assets/images/icons/applePay.svg";
import dateIcon from "assets/images/icons/date.svg";
import cardIcon from "assets/images/icons/card.svg";
import discountIcon from "assets/images/icons/discount.svg";
import walletIcon2 from "assets/images/icons/wallet2.svg";
import Riyal from "assets/images/icons/riyal.svg";

const OrderDetails = () => {
  const { t } = useTranslation();
  document.title = t("Booking Details | Work Space");

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const dispatch = useDispatch();
  const { loading, isLoading, orderDetails } = useSelector(
    (state) => state.Orders
  );

  const [show, setShow] = useState(false);

  useEffect(() => {
    dispatch(getOrderDetails({ id }));
  }, []);

  const handleClose = () => {
    setShow(false);
  };

  const handleGenerateInvoice = () => {
    const payload = {
      bookingId: id,
    };
    dispatch(generateOrderInvoice(payload)).then((action) => {
      const { statusCode, success, message, data } = action?.payload;
      if (statusCode === 200 && success) {
        data && window.open(data, "_blank");
      } else {
        dispatch(showAlert({ text: message, type: "error" }));
      }
    });
  };

  const [refundMethod, setRefundMethod] = useState(null);

  useEffect(() => {
    if (!loading) {
      const updatedMethod =
        orderDetails?.refund?.amount ===
        Number(orderDetails?.splitPayments?.walletAmount) +
          Number(orderDetails?.splitPayments?.gatewayAmount)
          ? "WALLET"
          : "SPLIT";
      setRefundMethod(updatedMethod);
    }
  }, [orderDetails, loading]);

  return (
    <React.Fragment>
      <div className="page-content common_details_page order_details">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <DetailsPageTitle
                title={`${t("Booking")} #${orderDetails?.bookingNo}`}
              />
            </Row>
            <div className="common_wrapper">
              {/* TABLE VIEW FOR ORDER DETAILS */}
              <Row>
                <Col lg={12}>
                  <div className="common_table_style w-100">
                    <Table>
                      <thead className="t_head">
                        <tr>
                          <th>{t("Booking Date")}</th>
                          <th>{t("Status")}</th>
                          <th>{t("Booking No")}</th>
                          <th>{t("User")}</th>
                          <th>{t("Number")}</th>
                          <th>{t("Booking Date")}</th>
                          <th>{t("Booking Time")}</th>
                          <th>{t("Booking")}</th>
                          <th>{t("Qty")}</th>
                          <th>{t("Coupon")}</th>
                          <th>{t("Total")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {getRelativeTimeFromNow(orderDetails.createdAt)}
                          </td>
                          <td>
                            <p
                              className={` w_fit_content  ${
                                orderStatusTypes?.find(
                                  (option) =>
                                    option.value === orderDetails.bookingStatus
                                )?.class
                              }`}
                            >
                              {t(
                                orderStatusTypes?.find(
                                  (option) =>
                                    option.value === orderDetails.bookingStatus
                                )?.name
                              ) || "-"}
                            </p>
                          </td>
                          <td>#{orderDetails?.bookingNo || "-"}</td>
                          <td>
                            <Link
                              to={`/customers/customer-information?id=${orderDetails?.userId?._id}`}
                              className="text_primary text-decoration-underline"
                            >
                              {orderDetails?.userId?.name || "-"}
                            </Link>
                          </td>
                          <td>{orderDetails?.userId?.phone || "-"}</td>
                          <td>
                            {formatDate(
                              orderDetails?.bookingDate,
                              "dd MMM yyyy"
                            )}
                          </td>
                          <td>
                            <p className="w_fit_content">
                              {orderDetails?.startTime} -{" "}
                              {orderDetails?.endTime}
                            </p>
                          </td>
                          <td>
                            <div style={{ minWidth: 200 }}>
                              <p>
                                {
                                  orderSpaceType?.find(
                                    (option) =>
                                      option.value ===
                                      orderDetails?.spaceTypeInt
                                  )?.name
                                }{" "}
                                - {orderDetails?.spaceId?.name}
                              </p>
                              <p className="fs_12 text_gray">
                                <span>{orderDetails?.cityId?.name}</span>
                                {", "}
                                <span>{orderDetails?.branchId?.name}</span>
                              </p>
                            </div>
                          </td>
                          <td>
                            {" "}
                            {orderDetails?.spaceTypeInt === 1
                              ? orderDetails?.numberOfseats
                              : [2, 3].includes(orderDetails?.spaceTypeInt)
                              ? `${orderDetails?.durationInHour}h`
                              : ""}
                          </td>
                          <td>
                            {orderDetails?.coupon ? (
                              <p className="text_primary fs_12 text-decoration-underline">
                                {orderDetails?.coupon?.code}
                              </p>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>
                            <img
                              src={Riyal}
                              width={12}
                              height={12}
                              alt="riyal"
                              className="me-1"
                            />
                            {orderDetails?.splitPayments?.total}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="common_card_inner price_details">
                    <h2 className="fs_20 text_black mb-2">
                      {t("Price Details")}
                    </h2>
                    <div>
                      <div className="single_item g_between">
                        <h2>{t("Transaction Id")}</h2>
                        <h2>
                          {orderDetails?.transaction?.transactionId || "-"}
                        </h2>
                      </div>
                      {orderDetails.paymentMethod && (
                        <div className="single_item g_between">
                          <h2>{t("Payment Method")}</h2>
                          <h2>
                            <img
                              src={
                                orderDetails.paymentMethod === "APPLE"
                                  ? applePayIcon
                                  : orderDetails.paymentMethod === "CARD"
                                  ? cardIcon
                                  : orderDetails.paymentMethod ===
                                    "FULL_DISCOUNT"
                                  ? discountIcon
                                  : orderDetails.paymentMethod === "WALLET"
                                  ? walletIcon2
                                  : ""
                              }
                              title={orderDetails.paymentMethod}
                              alt="wallet"
                              width={20}
                              height={20}
                              className="mb-1 mx-1"
                            />
                            <span>{orderDetails.paymentMethod || "-"}</span>
                          </h2>
                        </div>
                      )}

                      {orderDetails?.spaceTypeInt === 1 && (
                        <>
                          <div className="single_item g_between">
                            <h2>{t("Number Of Seats")}</h2>
                            <h2>{orderDetails?.numberOfseats}</h2>
                          </div>
                        </>
                      )}
                      {[2, 3].includes(orderDetails?.spaceTypeInt) && (
                        <>
                          <div className="single_item g_between">
                            <h2>{t("Total Hours")}</h2>
                            <h2>
                              {orderDetails?.durationInHour}{" "}
                              {orderDetails?.durationInHour === 1
                                ? t("Hour")
                                : t("Hours")}
                            </h2>
                          </div>
                        </>
                      )}

                      <div className="single_item g_between">
                        <h2>{t("Date & Time")}</h2>
                        <h2>
                          {orderDetails?.startTime},{" "}
                          {formatDate(orderDetails?.bookingStartDate)}
                        </h2>
                      </div>
                      <div className="single_item g_between">
                        <h2>{t("Sub Total")}</h2>
                        <h2>
                          {orderDetails?.refund && "- "}
                          <img
                            src={Riyal}
                            width={15}
                            height={15}
                            alt="riyal"
                            className="me-1"
                          />
                          {orderDetails?.splitPayments?.total}
                        </h2>
                      </div>
                      <div className="single_item g_between">
                        <h2>
                          {t("Tax")}
                          {orderDetails?.splitPayments?.vatValue}
                        </h2>
                        <h2>
                          {orderDetails?.refund && "- "}
                          <img
                            src={Riyal}
                            width={15}
                            height={15}
                            alt="riyal"
                            className="me-1"
                          />
                          {orderDetails?.splitPayments?.vatAmount}
                        </h2>
                      </div>
                      <div className="single_item g_between">
                        <h2>{t("Discounted Amount")}</h2>
                        <h2>
                          {orderDetails?.refund && "- "}
                          <img
                            src={Riyal}
                            width={15}
                            height={15}
                            alt="riyal"
                            className="me-1"
                          />
                          {orderDetails?.splitPayments?.discountedAmount}{" "}
                        </h2>
                      </div>
                      <div className="single_item g_between">
                        <h2>{t("Wallet Amount")}</h2>
                        <h2>
                          {orderDetails?.refund && "- "}
                          <img
                            src={Riyal}
                            width={15}
                            height={15}
                            alt="riyal"
                            className="me-1"
                          />
                          {orderDetails?.splitPayments?.walletAmount}
                        </h2>
                      </div>
                      {/* <div className="single_item g_between">
                        <h2>{t("Insurance")}</h2>
                        <h2>5.25  </h2>
                      </div> */}
                      <div className="single_item g_between mt-3">
                        <h2>{t("Total")}</h2>
                        <h2>
                          {orderDetails?.refund && "- "}
                          <img
                            src={Riyal}
                            width={15}
                            height={15}
                            alt="riyal"
                            className="me-1"
                          />
                          {orderDetails?.splitPayments?.total}
                        </h2>
                      </div>
                      <div className="single_item g_between">
                        <h2>{t("Paid Amount")}</h2>
                        <h2>
                          {orderDetails?.refund && "- "}
                          <img
                            src={Riyal}
                            width={15}
                            height={15}
                            alt="riyal"
                            className="me-1"
                          />
                          {orderDetails?.splitPayments?.gatewayAmount}{" "}
                        </h2>
                      </div>

                      {(orderDetails?.refund || orderDetails?.bookingStatus == 3) && (
                        <>
                          {/* REFUNDED AMOUNT */}
                          <hr className="mt-4" />
                          <div className="mt_18">
                            <div className="single_item g_between">
                              <h2 className="text_blue_2">
                                {t("Refunded Amount")}
                              </h2>
                              <h2 className="text_blue_2">
                                <img
                                  src={Riyal}
                                  width={15}
                                  height={15}
                                  alt="riyal"
                                  className="me-1"
                                />
                                {Number(
                                  orderDetails?.splitPayments?.walletAmount
                                ) +
                                  Number(
                                    orderDetails?.splitPayments?.gatewayAmount
                                  )}
                              </h2>
                            </div>
                          </div>
                          <div className="refunded_amount_inner mt_18">
                            <h2 className="text_gray fs_12">
                              {t("Refund Method")}
                            </h2>
                            <h2 className="fs_14 mt-1">
                              {refundMethod === "WALLET"
                                ? t("Wallet")
                                : t("Split (Wallet + Payment Method)")}
                            </h2>
                            <div className="refund_inner">
                              <div className="d-flex align-items-center gap-2">
                                <img
                                  src={walletIcon}
                                  alt="wallet"
                                  width={15}
                                  height={15}
                                />
                                <h2 className="fs_14">
                                  {t("Refund to Wallet:")}{" "}
                                  <span className="text_blue_2">
                                    <img
                                      src={Riyal}
                                      width={15}
                                      height={15}
                                      alt="riyal"
                                      className="me-1"
                                    />

                                    {refundMethod === "WALLET" ? orderDetails?.refund?.amount : orderDetails?.splitPayments?.walletAmount}
                                  </span>
                                </h2>
                              </div>
                              {refundMethod === "SPLIT" && (
                                <div className="d-flex align-items-center gap-2">
                                  <img
                                    src={paymentMethodIcon}
                                    alt="wallet"
                                    width={15}
                                    height={15}
                                  />
                                  <h2 className="fs_14">
                                    {t("Original Payment Method")} -{" "}
                                    {orderDetails.paymentMethod && (
                                      <img
                                        src={
                                          orderDetails.paymentMethod === "APPLE"
                                            ? applePayIcon
                                            : orderDetails.paymentMethod ===
                                              "CARD"
                                            ? cardIcon
                                            : orderDetails.paymentMethod ===
                                              "FULL_DISCOUNT"
                                            ? discountIcon
                                            : orderDetails.paymentMethod ===
                                              "WALLET"
                                            ? walletIcon2
                                            : ""
                                        }
                                        title={orderDetails.paymentMethod}
                                        alt="wallet"
                                        width={27}
                                        height={12}
                                      />
                                    )}
                                    :{" "}
                                    <span className="text_blue_2">
                                      <img
                                        src={Riyal}
                                        width={15}
                                        height={15}
                                        alt="riyal"
                                        className="me-1"
                                      />
                                      {
                                        orderDetails?.splitPayments
                                          ?.gatewayAmount
                                      }{" "}
                                    </span>
                                  </h2>
                                </div>
                              )}
                            </div>
                            <h2 className="text_gray fs_12 mt-3">
                              {t("Refund Date")}
                            </h2>
                            <div className="d-flex align-items-center gap-2 mt-2">
                              <img
                                src={dateIcon}
                                alt="date"
                                width={15}
                                height={15}
                              />
                              <h2 className="fs_14">
                                {formatToCustomDateTime(
                                  orderDetails?.refund?.createdAt
                                )}
                              </h2>
                            </div>
                          </div>
                        </>
                      )}

                      <button
                        className="main_btn_3 mt-4 ms-auto d-block"
                        onClick={handleGenerateInvoice}
                        disabled={isLoading}
                      >
                        {t("Invoice")}
                      </button>
                    </div>
                  </div>
                </Col>
                <Col lg={6}>
                  <Row>
                    {orderDetails?.isRated && (
                      <Col lg={12}>
                        <div className="common_card_inner rating_details">
                          <h2 className="fs_20 text_black">{t("Rating")}</h2>
                          <div>
                            <CustomStar rating={orderDetails?.rating?.rating} />
                          </div>
                          <h3 className="fs_14">
                            {orderDetails?.rating?.feedback}
                          </h3>
                        </div>
                      </Col>
                    )}

                    {(orderDetails?.bookingStatus === 2 ||
                      orderDetails?.bookingStatus === 3) && (
                      <Col lg={12}>
                        <div className="common_card_inner rating_details">
                          <h2 className="fs_20 text_black">
                            {t("Cancellation Details")}
                          </h2>

                          <div className="d-flex gap-5">
                            <div>
                              <h3 className="fs_14 mt-2">
                                {t("Cancelled By")}{" "}
                                {orderDetails?.cancelInfo?.cancelleType === 1
                                  ? t("User")
                                  : orderDetails?.cancelInfo?.cancelleType === 2
                                  ? t("Admin")
                                  : ""}
                              </h3>
                              <p
                                className={`fs_14 ${
                                  orderDetails?.cancelInfo?.cancelleType === 2
                                    ? "text_blue_3"
                                    : ""
                                } `}
                              >
                                {orderDetails?.cancelledBy?.name || ""}
                              </p>
                            </div>
                            <div>
                              <h3 className="fs_14 mt-2">
                                {t("Cancellation Date")}
                              </h3>
                              <p className="fs_14">
                                {formatDate(
                                  orderDetails?.cancelInfo?.cancelledAt
                                )}
                              </p>
                            </div>
                          </div>
                          {orderDetails?.cancelInfo?.cancelledNote && (
                            <div className="cancellation_reason_div">
                              <h2 className="fs_12 text_dark_gray">
                                {t("Cancellation Reason")}
                              </h2>
                              <h3 className="fs_14 mt-2">
                                {orderDetails?.cancelInfo?.cancelledNote || "-"}
                              </h3>
                            </div>
                          )}
                        </div>
                      </Col>
                    )}
                    <Col lg={12}>
                      <div className="common_card_inner order_customer_details">
                        <p className="fs_14 text_gray">{t("Name")}</p>
                        <Link
                          to={`/customers/customer-information?id=${orderDetails?.userId?._id}`}
                          className="fs_20 text-decoration-underline text_primary mb-2"
                        >
                          {orderDetails?.userId?.name}
                        </Link>
                        <div className="d-flex flex-wrap gap-5 mt-4">
                          <div className="inner_details">
                            <h2>{t("Gender")}</h2>
                            <h3>
                              {t(
                                genderOptions?.find(
                                  (option) =>
                                    option.value ===
                                    orderDetails?.userId?.gender
                                )?.name
                              )}
                            </h3>
                          </div>
                          <div className="inner_details">
                            <h2>{t("Age")}</h2>
                            <h3>{orderDetails?.userId?.dob}</h3>
                          </div>
                          <div className="inner_details">
                            <h2>{t("Status")}</h2>
                            <h3>
                              {t(
                                userRoleType?.find(
                                  (option) =>
                                    option.value ===
                                    orderDetails?.userId?.roleType
                                )?.name
                              )}
                            </h3>
                          </div>
                          <div className="inner_details">
                            <h2>{t("Number")}</h2>
                            <h3>{orderDetails?.userId?.phone}</h3>
                          </div>
                        </div>
                        <div className="inner_details mt-4">
                          <h2>
                            {t("Member since")}{" "}
                            {formatDate(orderDetails?.userId?.createdAt)}
                          </h2>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            {/* SHOW CANCEL BOOKING BUTTON ONLY FOR COMPLETED STATUS */}
            {[1]?.includes(orderDetails.bookingStatus) && (
              <div className="g_end">
                <button
                  className="danger_btn mt-3"
                  onClick={() => setShow(true)}
                >
                  {t("Cancel Booking")}
                </button>
              </div>
            )}
          </Container>
        )}
      </div>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        className="common_modal cancel_order_modal"
      >
        <CancelOrder setShow={setShow} orderDetails={orderDetails} />
      </Modal>
    </React.Fragment>
  );
};

export default OrderDetails;
